import type { Enum } from '@/types/Enum'
import type { FederalGrantSearchFilter } from '@/types/federal-grant/Filter'

export const DEFAULT_FEDERAL_GRANT_FILTER: FederalGrantSearchFilter = {
  is_active: null,
  active_after: null,
  active_before: null,
  published_after: null,
  published_before: null,
  agencies: [],
  eligible_applicants: [],
  funding_categories: [],
  funding_instruments: [],
  opportunity_categories: [],
  statuses: [],
}

export const STATUS_NAMES: Array<Enum> = [
  {
    id: 'Forecasted',
    title: 'Forecasted',
  },
  {
    id: 'Posted',
    title: 'Posted',
  },
]

export const ELIGIBLE_APPLICANTS: Array<string> = [
  'City or Township Governments',
  'County Governments',
  'Federally Recognized Native American Tribal Governments',
  'For-Profit Organizations',
  'Individuals',
  'Independent School Districts',
  'Nonfederally Recognized Native American Tribal Organizations',
  'Nonprofits Without 501(c)(3) Status',
  'Others',
  'Private Institutions of Higher Education',
  'Public and State Controlled Institutions of Higher Education',
  'Public Housing Authorities/Indian Housing Authorities',
  'Small Businesses',
  'Special District Governments',
  'State Governments',
  'Unrestricted',
]

export const FUNDING_CATEGORIES: Array<string> = [
  'Affordable Care Act',
  'Agriculture',
  'Arts',
  'Business and Commerce',
  'Community Development',
  'Consumer Protection',
  'Disaster Prevention and Relief',
  'Education',
  'Employment, Labor and Training',
  'Energy',
  'Energy Infrastructure and Critical Mineral and Materials',
  'Environment',
  'Food and Nutrition',
  'Health',
  'Housing',
  'Humanities',
  'Income Security and Social Services',
  'Information and Statistics',
  'Infrastructure Investment and Jobs Act',
  'Law, Justice and Legal Services',
  'Natural Resources',
  'Other',
  'Opportunity Zone Benefits',
  'Recovery Act',
  'Recreation and Tourism',
  'Regional Development',
  'Science and Technology and other Research and Development',
  'Transportation',
]

export const FUNDING_INSTRUMENTS: Array<string> = [
  'Cooperative Agreement',
  'Grant',
  'Procurement Contract',
  'Other',
]

export const OPPORTUNITY_CATEGORIES: Array<string> = [
  'Continuation',
  'Discretionary',
  'Earmark',
  'Mandatory',
  'Other',
]
